import { render, staticRenderFns } from "./StepHeading.vue?vue&type=template&id=ccd487ac&scoped=true&"
import script from "./StepHeading.vue?vue&type=script&lang=js&"
export * from "./StepHeading.vue?vue&type=script&lang=js&"
import style0 from "./StepHeading.vue?vue&type=style&index=0&id=ccd487ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccd487ac",
  null
  
)

export default component.exports